import initialState from './initial';
import { StatisticActionDataTypes } from './actions';

function reducer(state = initialState, action) {
  switch (action.type) {
    case StatisticActionDataTypes.ACTION_PROCESSING: {
      const actionProcessing = action.payload?.[StatisticActionDataTypes.ACTION_PROCESSING]?.actionProcessing;

      if (actionProcessing !== undefined) return { ...state, actionProcessing };
      return state;
    }

    case StatisticActionDataTypes.GET_STATISTIC: {
      const { general, users, transfers, bets } = action.payload?.[StatisticActionDataTypes.GET_STATISTIC] ?? {};

      if (general !== undefined && users !== undefined && transfers !== undefined && bets !== undefined) {
        return { ...state, general, users, transfers, bets };
      }

      return state;
    }

    default:
      return state;
  }
}

export default reducer;
